exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width:40em){\n.tel[data-v-1247df64]{display:grid;grid-gap:30px;grid-template-columns:2fr 2fr 3fr\n}\n}", ""]);

// exports
